import React from "react";
import QurealRichEditor from "./QurealRichEditor";

const QurealStandardBubbleEditor = (props) => {
    const {
        placeholder = {
            heading: "Add heading...",
            paragraph: "Start writing or type '/' for commands...",
        },
    } = props;
    return (
        <QurealRichEditor
            {...props}
            editorOptions={{
                includeTable: true,
                includeMedia: true,
                includeFormatting: true,
                includeAlignment: true,
            }}
            placeholder={placeholder}
            menuFeatures="all"
            menuType="bubble"
        />
    );
};

export default QurealStandardBubbleEditor;
